// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__wmmm4","link":"HeaderSimple_link__j4Nl2"};